export default __webpack_public_path__ + "static/media/GlassBeer2_sm.b1aab4b5.jpg";